import { Enum, EnumType } from 'ts-jenum';

@Enum<BrickLayoutType>('value')
export class BrickLayoutType extends EnumType<BrickLayoutType>() {
   static readonly DEFAULT_WALL = new BrickLayoutType(0);
   static readonly PILOT_PANEL = new BrickLayoutType(1);
   static readonly IN_LAYOUT_BRICK = new BrickLayoutType(2);

   constructor(public value: number) {
      super();
   }
}
